export default __webpack_public_path__ + "static/media/ChevronLeft.e12dcb66.svg";